// Test IDs for ATLAS™ — marketing, auth, app, admin.
export const MARKETING = {
  navHome: 'nav-home',
  navProduct: 'nav-product',
  navPricing: 'nav-pricing',
  navCapital: 'nav-capital-raising',
  navLogin: 'nav-login',
  navSignup: 'nav-signup',
  heroRequestDemo: 'hero-request-demo-btn',
  heroDiscovery: 'hero-discovery-btn',
  ctaFooter: 'cta-footer-btn',
  demoFormName: 'demo-form-name',
  demoFormEmail: 'demo-form-email',
  demoFormOrg: 'demo-form-org',
  demoFormRole: 'demo-form-role',
  demoFormSize: 'demo-form-size',
  demoFormMessage: 'demo-form-message',
  demoFormSubmit: 'demo-form-submit',
  pricingCtaOrg: 'pricing-cta-org',
  pricingCtaIndividual: 'pricing-cta-individual',
  capitalCheckout: 'capital-checkout-btn',
};

export const AUTH = {
  loginEmail: 'login-email-input',
  loginPassword: 'login-password-input',
  loginSubmit: 'login-submit-button',
  loginToSignup: 'login-to-signup',
  signupName: 'signup-name-input',
  signupEmail: 'signup-email-input',
  signupPassword: 'signup-password-input',
  signupOrgName: 'signup-org-name-input',
  signupInvite: 'signup-invite-input',
  signupSubmit: 'signup-submit-button',
  signupToLogin: 'signup-to-login',
  signupTypeEntrepreneur: 'signup-type-entrepreneur',
  signupTypeOrganization: 'signup-type-organization',
  signupTypeInvite: 'signup-type-invite',
};

export const APP = {
  sidebar: 'app-sidebar',
  logout: 'logout-button',
  navDashboard: 'app-nav-dashboard',
  navOnboarding: 'app-nav-onboarding',
  navHealth: 'app-nav-health',
  navEinstein: 'app-nav-einstein',
  navPlan: 'app-nav-plan',
  navAuditor: 'app-nav-auditor',
  navMarketing: 'app-nav-marketing',
  navIndustry: 'app-nav-industry',
  navPitch: 'app-nav-pitch',
  navFinancials: 'app-nav-financials',
  navCapital: 'app-nav-capital',
  navAssets: 'app-nav-assets',
  navOrgAdmin: 'app-nav-org-admin',
  navJudge: 'app-nav-judge',
  navPlatform: 'app-nav-platform',
  dnaNext: 'dna-next-button',
  dnaBack: 'dna-back-button',
  dnaSave: 'dna-save-button',
  healthGenerate: 'health-generate-button',
  einsteinInput: 'einstein-input',
  einsteinSend: 'einstein-send',
  einsteinNewSession: 'einstein-new-session',
  agentGenerate: 'agent-generate-button',
  agentExtraContext: 'agent-extra-context',
  assetDownloadDocx: 'asset-download-docx',
  assetDownloadPdf: 'asset-download-pdf',
  createInviteCode: 'create-invite-code',
};
